module.exports = __webpack_public_path__ + "static/media/Finansii-Mobile-mk.0df73de5.jpg";